let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9dhzF"), load("iNmir"), load("hzVe9")]).then(() => parcelRequire('dSB3l'));